// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-overview-hero {
    background: linear-gradient(135deg, #1a0a0a 0%, #2a1010 30%, #3a1515 60%, rgba(229, 57, 53, 0.4) 100%);
    border-radius: 20px;
    padding: 32px 36px;
    margin-bottom: 28px;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(229, 57, 53, 0.2);
}

.sa-overview-hero::before {
    content: "";
    position: absolute;
    top: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: rgba(229, 57, 53, 0.08);
}

.sa-stats-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 14px;
    margin-bottom: 28px;
}

.sa-overview-split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 28px;
}

.sa-stat-card {
    background: var(--sa-card);
    border-radius: 14px;
    padding: 20px 18px;
    transition: transform 0.15s;
    cursor: default;
}

.sa-stat-card:hover {
    transform: translateY(-2px);
}

.sa-stat-value {
    font-size: 32px;
    font-weight: 800;
    font-family: 'Sora', sans-serif;
}

.sa-quick-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
}

.sa-action-card {
    padding: 16px 14px;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.15s;
    display: flex;
    align-items: center;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SAOverview.css"],"names":[],"mappings":"AAAA;IACI,sGAAsG;IACtG,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":[".sa-overview-hero {\n    background: linear-gradient(135deg, #1a0a0a 0%, #2a1010 30%, #3a1515 60%, rgba(229, 57, 53, 0.4) 100%);\n    border-radius: 20px;\n    padding: 32px 36px;\n    margin-bottom: 28px;\n    position: relative;\n    overflow: hidden;\n    border: 1px solid rgba(229, 57, 53, 0.2);\n}\n\n.sa-overview-hero::before {\n    content: \"\";\n    position: absolute;\n    top: -50px;\n    right: -50px;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n    background: rgba(229, 57, 53, 0.08);\n}\n\n.sa-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 14px;\n    margin-bottom: 28px;\n}\n\n.sa-overview-split {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 20px;\n    margin-bottom: 28px;\n}\n\n.sa-stat-card {\n    background: var(--sa-card);\n    border-radius: 14px;\n    padding: 20px 18px;\n    transition: transform 0.15s;\n    cursor: default;\n}\n\n.sa-stat-card:hover {\n    transform: translateY(-2px);\n}\n\n.sa-stat-value {\n    font-size: 32px;\n    font-weight: 800;\n    font-family: 'Sora', sans-serif;\n}\n\n.sa-quick-actions {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n}\n\n.sa-action-card {\n    padding: 16px 14px;\n    border-radius: 12px;\n    cursor: pointer;\n    transition: all 0.15s;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
